import { render } from "./ImageGalleryModal.vue?vue&type=template&id=bc007346&scoped=true&ts=true"
import script from "./ImageGalleryModal.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryModal.vue?vue&type=script&lang=ts"

import "./ImageGalleryModal.vue?vue&type=style&index=0&id=bc007346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc007346"]])

export default __exports__